import React from 'react';
import Switch from "react-switch"
import { Button, Input, Label } from 'reactstrap';

const CustomInputWithButton = ({
    id,
    name,
    label,
    type = 'text',
    value,
    onChange,
    placeholder = '',
    buttonLabel = 'Go',
    onButtonClick,
    className = '',
    textAlignment = 'start', // use 'start', 'center', or 'end'
    input1Disabled = false,
    buttonDisabled = false,
    colorClass = 'btn-outline-primary', // bootstrap button color class
    handleSwitchToggle,
    isSwitchEnabled,
    hideSwitch = false,
    hideButton = false,
    ...props
}) => {
    return (
        <div className={`mb-2 ${className}`}>
            {label && (
                <Label htmlFor="example-text-input" className={`col-form-label-sm`}>
                    {label}
                </Label>
            )}
            <div className="input-group">
                <Input
                    name={name}
                    id={id}
                    type={type}
                    className={`form-control form-control-sm text-${textAlignment}`}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    disabled={input1Disabled}
                    {...props}
                />
                {!hideButton ? <Button
                    type="button"
                    color='success'
                    size='sm'
                    onClick={onButtonClick}
                    disabled={buttonDisabled}
                >
                    <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                    ></i>
                </Button> : null}
                <div className="d-flex align-items-center ms-3">
                    {!hideSwitch ? <Switch
                        onChange={handleSwitchToggle}
                        checked={isSwitchEnabled}
                        height={20}
                        width={40}
                        handleDiameter={18}
                        offColor="#bbb"
                        onColor="#0d6efd"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        id={`${id}-switch`}

                    /> : <div style={{ width: 40, height: 20 }}></div>}
                </div>
            </div>
        </div>
    );
};

export default CustomInputWithButton;
